import { render } from "./vitals-type.vue?vue&type=template&id=2ccf96c3&scoped=true"
import script from "./vitals-type.vue?vue&type=script&lang=js"
export * from "./vitals-type.vue?vue&type=script&lang=js"

import "./vitals-type.vue?vue&type=style&index=0&id=2ccf96c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccf96c3"]])

export default __exports__